<div fxLayout="column">
    <div fxFlex="1 1 auto" class='dashboard-metric-type'>
        <span>{{dashboardMetricSet.label}}</span>
    </div>
    <div fxFlex="1 1 auto" fxLayout="row">
        <div class="metric-holder" fxFlex="1 1 auto">
            <div fxLayout="row">
                <span fxFlex="1 1 auto" class="dashboard-metric-value dashboard-metric-center"
                    [style.font-size]="dashboardMetricSet.fontSize">{{dashboardMetricSet.values[0] || '--'}}</span>
            </div>
        </div>
    </div>
</div>